/*eslint-disable*/
import easydropdown from 'easydropdown'
export default el => {
    const sel = el.querySelector('select')
    if (sel) {
        let edd = easydropdown(sel, {
            behavior: {
                useNativeUiOnMobile: false,
                showPlaceholderWhenOpen: true,
                liveUpdates: true,
            },
            classNames: {
                rootOpenBelow: true
            },
            callbacks: {
                onSelect: value => {
                    let selected = $(`.easy-drop-mobile .edd-select option[data-value*="${value}"]`)
                    window.location = $(selected).attr('data-url')
                },
            }
        })
    }
}




// WEBPACK FOOTER //
// ./src/scripts/components/mobile-clp-dropdown.js